import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const SummarySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const FiltersSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  margin: 0;
`

export const ResetButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const AddFilterContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const ActionsContainer = styled.div`
  display: grid;
  grid-gap: ${props => props.theme.spacing.sp16};
  grid-template-columns: 1fr 1fr;
  width: 100%;
  padding: ${props => props.theme.spacing.sp40} 0;
`
